import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

type SignInPayload = {
  email: string;
  password: string;
};

const signIn = async (data: SignInPayload) => {
  const response = await axios.post('/api/auth/signin', data);
  return response.data;
};

export const useSignIn = (
  onSuccess?: () => void,
  onError?: (error: any) => void,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SignInPayload) => signIn(data),
    onSuccess: (user) => {
      queryClient.setQueriesData({ queryKey: ['me'] }, () => ({
        ...user,
      }));
      onSuccess?.();
    },
    onError,
  });
};
